<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <BaseTextInput label="Instancia que informa" :value="evaluacion.instanciaInformadora" readonly />
      </v-col>
      <v-col cols="6">
        <BaseTextInput label="Periodicidad" :value="evaluacion.periodicidad" readonly />
      </v-col>
      <v-col cols="4">
        <BaseTextInput label="Fecha de inicio" :value="evaluacion.fechaInicio" readonly />
      </v-col>
      <v-col cols="4">
        <BaseTextInput label="Fecha de conclusión" :value="evaluacion.fechaConclusion" readonly />
      </v-col>
      <v-col cols="4">
        <BaseTextInput label="Fecha de aplicación" :value="evaluacion.fechaAplicacion" readonly />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseTextInput from '../../../base/BaseTextInput.vue'

export default {
  components: { BaseTextInput },

  props: {
    evaluacion: {
      type: Object,
      required: true,
    },
  },
}
</script>
